<template>
  <div>
    <div ref="selectcontainer" class="">
      <v-select
        ref="select"
        v-model="modelVSelect"
        :disabled="disabled"
        :multiple="isMultiple"
        :placeholder="placeHolderSearch"
        :options="optionSearch"
        label="title"
        :clearable="true"
        :selectable="(option) => selectableVSelect(option)"
        :filterable="false"
        style="background-color: white"
        :clear-search-on-blur="clearSearchSub"
        @search="searchVSelect"
        @input="inputVSelect"
        @open="onOpen"
        @close="onClose"
      >
        <div slot="no-options">
          <span>{{ checkNodata ? messNoOption : messPlaceHolderOption }}</span>
        </div>
        <template slot="option" slot-scope="option">
          <div class="container-option">
            <div class="container-option-id">
              <span v-if="isShowID" class="color-blur"> #{{ option.id }} </span>
            </div>
            <div class="container-option-1">
              <div class="is-flex is-flex-direction-column">
                <div class="is-flex">
                  <b class="is-break-words">{{
                    option.title ? option.title : ""
                  }}</b>
                  <!-- <div class="ml-3">
                    <span
                      v-if="showType && option.type.name === 'wine_bundle'"
                      class="badge__search "
                      style="padding:5px"
                    >{{option.type.name === 'wine' ? 'Wine' : option.type.name === 'wine_bundle' ? 'Bundle' : null}}</span>
                  </div> -->
                </div>
                <!-- <b class="is-break-words">{{option.name}}</b> -->
              </div>
            </div>
            <!-- <div class="container-option-2">
              <div class="is-flex is-flex-direction-column is-align-items-flex-end">
                <div
                  v-if="isShowPrice"
                  class="is-flex is-align-items-center"
                >

                </div>

                <div>

                  <span class="color-blur">
                  </span>
                </div>
              </div>
            </div> -->
          </div>
        </template>
        <template #open-indicator="{ attributes }">
          <span v-bind="attributes" class="dp-contents">
            <i :class="iconSearch" aria-hidden="true" />
          </span>
        </template>
        <template #list-footer>
          <div
            v-if="hasInfinity"
            ref="load"
            class="has-text-centered is-flex is-justify-content-center is-align-items-center"
          >
            <i class="fa fa-spinner fa-pulse mr-5" /> <span>Loading ...</span>
          </div>
        </template>
      </v-select>
    </div>
  </div>
</template>
<script>
  // HOW TO USE
  // - import component
  // - 'result' is result search
  // - 'placeHolderSearch' is string, placeHolder default
  // - 'filter' is filter to call api
  // --- Example ---
  // <search-component
  //             : arrResult.sync="listSearch" =>  singleSearch = false
  //             : result.sync="productSearch" => singleSearch = true
  //             : placeHolderSearch="'Enter a keyword to search'"
  //             : filter="filtersSearch"
  //             : iconSearch="'fa fa-search'"
  //             : singleSearch="false"
  //             : isShowPrice="true"
  //             : isShowStock="false"
  //             : isShowID="false"
  //              @input      =>> return item when selected
  // ></search-component>
  // Product default -> data o day tuong duong page = 1
  // Khi tu search sang infinite -> gan list product = default page 1 -> page  = 1 -> load tiep page 2
  import { post } from "api";
  import _ from "lodash";
  export default {
    name: "SearchProduct",
    components: {},
    props: {
      listcompare: {
        type: Array,
        default: () => [],
      },
      arrResult: Array,
      result: [Array, Object],
      resultMultiple: Array,
      placeHolderSearch: {
        type: String,
        default: "Enter Winemag Name or Offer ID to search.",
      },
      iconSearch: {
        type: String,
        default: "fa fa-search",
      },
      messNoOption: {
        type: String,
        default: "No winemag matched your search.",
      },
      messPlaceHolderOption: {
        type: String,
        default: "Enter Winemag Name or ID to search.",
      },
      filter: {
        type: Object,
        default: function () {
          return {
            // order: "desc",
            // only: "",
            // sort: "id",
            // category: "",
            // q: ""
            is_active: 1,
            q: "",
            type: "winemag",
          };
        },
      },
      isSelectOutStock: {
        type: Boolean,
        default: true,
      },
      selectable: {
        type: [Boolean, Function],
        default: true,
      },
      isShowID: {
        type: Boolean,
        default: true,
      },
      isShowPrice: {
        type: Boolean,
        default: true,
      },
      isShowStock: {
        type: Boolean,
        default: true,
      },
      singleSearch: {
        type: Boolean,
        default: false,
      },
      addFirst: {
        type: Boolean,
        default: false,
      },
      isMultiple: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      showType: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        // result: [],
        modelVSelect: [], //v-model select
        arrayCompareSearch: [], //list result
        listOptions: [], // list option to search
        dataSearchDefault: [],
        checkNodata: false,
        currency: "",
        filterDefault: { ...this.filter, limit: 10, page: 1 },
        total: "",
        isInfiniteScroll: true,
        observer: null,
        searchString: "",
        isLast: false,
      };
    },
    watch: {
      listcompare: {
        handler(newVal) {
          // Assign list product for comparison to disable
          // if (newVal.length !== 0) {
          this.arrayCompareSearch = newVal;
          // }
        },
        immediate: true,
        deep: true,
      },
      result: {
        handler(newVal) {
          this.initData();
        },
        immediate: true,
        deep: true,
      },
      filter: {
        handler(newVal) {
          this.filterDefault = { ...this.filterDefault, ...newVal };
        },
        immediate: true,
        deep: true,
      },
    },
    beforeDestroy() {
      this.observer.disconnect();
    },
    methods: {
      displayStock(stock) {
        if (stock == null || stock == undefined) return;
        const result = parseInt(stock);
        return result > 0 ? result : result < 0 ? "∞" : "0";
      },
      initData() {
        if (this.singleSearch) {
          this.modelVSelect = this.result ? this.result : null;
        }
        if (this.isMultiple && this.singleSearch) {
          this.modelVSelect = this.result ? [...this.result] : null;
        }
        if (!this.singleSearch) {
          // this.arrayCompareSearch = this.result ? this.result : []
        }
      },
      withPopper(dropdownList, component, { width }) {},
      selectableVSelect(option) {
        let result = true;
        // Check can select if product is out stock
        // if (!this.isSelectOutStock && option.status.includes('out_of_stock')) {
        //   return false
        // }
        // if (!this.selectable) return true
        // this.arrayCompareSearch.map(k => {
        //   if (option.id == k.id) {
        //     result = false
        //   }
        // if (!this.isSelectOutStock && option.status.includes('out_of_stock')) {
        //   result = false
        // }
        // })
        return result;
      },
      clearSearchSub(data) {
        return !data.clearSearchOnSelect && !data.multiple;
      },
      async searchVSelect(text, loading) {
        this.searchString = text;
        this.filter.q = this.searchString;
        if (!this.searchString && this.$refs.select.open) {
          this.listOptions = [...this.dataSearchDefault];
          // this.filterDefault.page = 1
          loading(false);
          await this.$nextTick();
          this.onOpen();
          return;
        } else if (this.searchString.length) {
          this.isInfiniteScroll = false;
          loading(true);
          this.searchDebounce(loading, text, this);
        }
      },
      searchDebounce: _.debounce((loading, text, vm) => {
        if (vm.searchString) {
          vm.getSearch(loading, text);
        }
      }, 500),
      async onOpen() {
        // Check if no search text & options list is open -> call infinite loading
        if (this.hasInfinity) {
          await this.$nextTick();
          this.observer.observe(this.$refs.load);
        }
        if (this.isLast) {
          return;
        }
        if (this.searchString == "" && this.$refs.select.open) {
          this.isInfiniteScroll = true;
        }
        if (this.listOptions.length < 10) {
          this.isInfiniteScroll = false;
        }
      },
      getSearch(loading, text) {
        post
          .searchWinemag(this.filter)
          .then((res) => {
            if (res.data.success) {
              this.listOptions = res.data.data;
              if (res.data.data.length > 0) {
                this.checkNodata = false;
              } else {
                this.checkNodata = true;
              }
              loading(false);
            }
          })
          .catch((err) => {
            loading(false);
          });
      },
      inputVSelect(data) {
        if (!this.singleSearch) {
          // this.listOptions = [];
          this.arrayCompareSearch = this.result ? [...this.result] : [];
          if (this.addFirst) {
            this.arrayCompareSearch.unshift(data);
          } else {
            this.arrayCompareSearch.push(data);
          }
          this.modelVSelect = [];

          this.$emit("update:result", this.arrayCompareSearch);
        } else {
          this.$emit("update:result", data);
        }
        if (this.isMultiple) {
          this.$emit("update:result", data);
        }
        this.$emit("input", data);
        if (!this.searchString) return;
        this.listOptions = [...this.dataSearchDefault];
        // this.arrayCompareSearch = []
      },
      getCurrency() {
        this.currency =
          this.$store && this.$store.getters.currency
            ? this.$store.getters.currency
            : JSON.parse(window.localStorage.getItem("vuex")).app.currency;
      },
      getDefault() {
        let loader = this.$loading.show({
          container: this.$refs.selectcontainer,
          isFullPage: false,
          width: 20,
          height: 20,
          opacity: 0.4,
        });
        post
          .searchWinemag(this.filterDefault)
          .then((res) => {
            loader.hide();
            if (res.data.success) {
              this.listOptions = res.data.data.data;
              this.dataSearchDefault = [...res.data.data.data];
              if (this.listOptions.length < 10) {
                this.isInfiniteScroll = false;
              }
            }
          })
          .catch((err) => {
            loader.hide();
          });
      },
      async infiniteScroll([{ isIntersecting, target }]) {
        if (isIntersecting) {
          const boxContainer = target.offsetParent;
          const scrollTop = target.offsetParent.scrollTop;
          this.filterDefault.page += 1;
          // if (this.filterDefault.page === 1) return
          try {
            const { data } = await post.searchWinemag(this.filterDefault);
            this.dataSearchDefault.push(...data.data.data);
            this.listOptions.push(...data.data.data);
            this.total = data.data.total;
            if (data.data.data.length < 10) {
              this.isInfiniteScroll = false;
              this.isLast = true;
            }
          } catch (error) {
            console.log("error :>> ", error);
          }
          await this.$nextTick();
          boxContainer.scrollTop = parseInt(scrollTop);
        }
      },
      onClose() {
        // this.filterDefault.page = 1
        if (this.searchString) return;
        // this.listOptions = [...this.dataSearchDefault]

        // this.observer.disconnect();
      },
    },
    mounted() {
      this.observer = new IntersectionObserver(this.infiniteScroll);
      this.getDefault();
    },
    created() {
      // this.getCurrency()
    },
    computed: {
      optionSearch() {
        return this.listOptions;
      },
      hasInfinity() {
        return this.isInfiniteScroll;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .vs--open .vs__open-indicator {
    //remove css transform rotate 180 icon search
    transform: none;
  }
  .dp-contents {
    display: contents;
  }
  .container-option {
    padding: 5px 0;
  }
  .container-option-id {
    .img {
      object-fit: contain;
    }
    display: flex;
    width: 40px;
    // height: 60px;
  }
  .container-option-1 {
    display: flex;
    flex: 7;
    align-items: center;
    white-space: normal;
  }
  .container-option-2 {
    display: flex;
    flex: 2;
    justify-content: flex-end;
    align-items: center;
  }
  .price-sale__custom {
    text-align: right;
    // padding-bottom: 5px;
    line-height: 8px;
  }
  .badge__search {
    background-color: #ccc;
    border-radius: 10px;
    padding: 0 4px;
    border-radius: 10px;
    font-size: 0.8em;
    width: 45px;
  }

  .color-blur {
    color: #969696;
  }
</style>
<style>
  .vs__selected-options > input.vs__search::placeholder {
    color: #ccc !important;
  }
</style>
